import { useEffect, useState, Fragment } from 'react';
import axios from 'axios';
import Header from './Header';
import DefaultSidebar from './Sidebar'
import { Card, Typography } from "@material-tailwind/react";
import ModalCreateCallEat from './ModalCreateCallEat'
import ModalModifyCallEat from './ModalModifyCallEat';


function ListCallEat() {
    const [datas, setDate] = useState([])
    const [sortedBy, setSortedBy] = useState()
    const [counter, setCounter] = useState(0)
    const [search, setSearch] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalModify, setShowModalModify] = useState(false);
    // const [open, setOpen] = useState('block')
    const [choosenCallEat, setChoosenCallEat] = useState({
        id_client: '', 
        nom_client: '', 
        room_id:'', 
        autorised:''
    });

    // Usage par room_id (table c_historique_CMD, agrégée côté back) : null = en chargement.
    const [usageMap, setUsageMap] = useState(null);
    const [showOnlyUnused, setShowOnlyUnused] = useState(false);

    useEffect(() => {

        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_client_calleat`)
            .then(res => {
                // console.log(res.data);
                setDate(res.data)
            }).catch(err => console.log(err))

        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_calleat_usage`)
            .then(res => {
                const map = {};
                (res.data || []).forEach(u => { map[String(u.room_id)] = { cmdCount: u.cmdCount, lastCmd: u.lastCmd }; });
                setUsageMap(map);
            }).catch(err => { console.log(err); setUsageMap({}); })
    }, [])

    const usageOf = (roomId) => (usageMap ? usageMap[String(roomId)] : undefined);
    const isUsed = (roomId) => !!usageOf(roomId);

    const relDate = (s) => {
        if (!s) return '';
        const t = new Date(String(s).replace(' ', 'T')).getTime();
        if (Number.isNaN(t)) return String(s);
        const d = Math.floor((Date.now() - t) / (24 * 3600 * 1000));
        if (d <= 0) return "aujourd'hui";
        if (d < 30) return `il y a ${d} j`;
        if (d < 365) return `il y a ${Math.floor(d / 30)} mois`;
        return `il y a ${Math.floor(d / 365)} an${d >= 730 ? 's' : ''}`;
    };

    const TABLE_HEAD = [
        { key: "nom_client", text: "Nom Client" },
        { key: "room_id", text: "Room ID" },
        { key: "autorised", text: "Autorisé" },
        { key: "usage", text: "Activité" },
    ];


    const sorted = datas.sort((a, b) => {

        const aVal = a[sortedBy];
        const bVal = b[sortedBy];
        if (typeof aVal === "number" && typeof bVal === "number") {
            if (counter % 2 === 0) return aVal - bVal;
            else return bVal - aVal;
        }
        else if (typeof aVal === "string" && typeof bVal === "string") {
            if (counter % 2 === 0) return aVal.localeCompare(bVal);
            else return bVal.localeCompare(aVal);
        }
        return 1;
    });

    const scrollToTop = () =>{ 
        window.scrollTo({ 
          top: 0,  
          behavior: 'smooth'
        }); 
      };


    const ListTable = (() => {
        return (
            <div className="w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                <div className="overflow-x-auto">
                    <table className="w-full min-w-max table-auto text-left">
                        <thead className="border-b border-slate-200 bg-slate-50">
                            <tr>
                                {TABLE_HEAD.map((head) => (
                                    <th
                                        key={head.key}
                                        className="cursor-pointer whitespace-nowrap px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-700"
                                        onClick={() => { setSortedBy(head.key); setCounter(counter + 1) }}
                                    >
                                        <span className="inline-flex items-center gap-1">
                                            {head.text}
                                            {sortedBy === head.key && (
                                                <span className="text-indigo-500">{counter % 2 === 0 ? '▲' : '▼'}</span>
                                            )}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {sorted.filter((item) => {
                                return search.toLowerCase() === ''
                                    ? item
                                    : item.nom_client.toLowerCase().includes(search.toLowerCase()) || item.room_id.toLowerCase().includes(search.toLowerCase())
                            }).filter((item) => !showOnlyUnused || !isUsed(item.room_id)).map((data, index) => {
                                const u = usageOf(data.room_id);
                                return (
                                    <tr key={data.id} className='cursor-pointer border-b border-slate-100 transition-colors hover:bg-indigo-50/40' onClick={() => {setShowModalModify(true); setChoosenCallEat({...choosenCallEat, id_client: data.id_client, nom_client: data.nom_client, room_id: data.room_id, autorised: data.autorised})}}>
                                        <td className="whitespace-nowrap px-4 py-3 text-sm text-slate-700">
                                            {data.nom_client}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3 text-sm text-slate-700">
                                            {data.room_id}
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3 text-sm text-slate-700">
                                            <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${data.autorised === 1 ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'}`}>
                                                {data.autorised === 1 ? 'Oui' : 'Non'}
                                            </span>
                                        </td>
                                        <td className="whitespace-nowrap px-4 py-3 text-sm text-slate-700">
                                            {usageMap === null ? (
                                                <span className="text-xs text-slate-400">…</span>
                                            ) : u ? (
                                                <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-medium text-emerald-700" title={`${u.cmdCount} commande(s), dernière : ${u.lastCmd}`}>
                                                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                                                    Utilisé · {relDate(u.lastCmd)}
                                                </span>
                                            ) : (
                                                <span className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-500">
                                                    <span className="h-1.5 w-1.5 rounded-full bg-slate-400" />
                                                    Jamais utilisé
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    })
    return (
        <Fragment>
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
            {/* <Header /> */}
            <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
                <div>
                    <h1 className="text-xl font-semibold text-slate-800">Clients CallEat</h1>
                    <p className="text-sm text-slate-500">
                        Gérez les clients CallEat, leurs rooms et autorisations.
                        {usageMap !== null && (
                            <span className="ml-1 text-slate-400">
                                ({datas.filter(d => !isUsed(d.room_id)).length} jamais utilisé{datas.filter(d => !isUsed(d.room_id)).length > 1 ? 's' : ''} sur {datas.length})
                            </span>
                        )}
                    </p>
                </div>
                <label className="flex cursor-pointer select-none items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm text-slate-600 shadow-sm hover:bg-slate-50">
                    <input
                        type="checkbox"
                        checked={showOnlyUnused}
                        onChange={(e) => setShowOnlyUnused(e.target.checked)}
                        className="h-4 w-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
                    />
                    Non utilisés uniquement
                </label>
            </div>
            <div className='mb-4 max-w-md'>
                {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 absolute left-1 cursor-pointer" onClick={() => setOpen(open === `hidden`  ? 'block' : 'hidden')} >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg> */}
                <div className="relative flex h-10 items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20">
                    <svg xmlns="http://www.w3.org/2000/svg" className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>

                    <input
                        className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                        type="text"
                        id="search"
                        placeholder="Rechercher..."
                        onChange={(e) => setSearch(e.target.value)} />
                </div>
            </div>
            <main className="mt-4">
                {/* <DefaultSidebar isOpen={open} /> */}
                {ListTable()}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-16 right-6 cursor-pointer" onClick={() => scrollToTop() }>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-6 right-6 cursor-pointer" onClick={() => setShowModal(true)}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
                </svg>
            </main>
        </div>
        <ModalModifyCallEat isVisible={showModalModify} onClose={() => setShowModalModify(false)} choosenCallEat={choosenCallEat}/>
        <ModalCreateCallEat isVisible={showModal} onClose={() => setShowModal(false)} /> 
        </Fragment>

    );
}
export default ListCallEat;